import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { EVSForm } from "./components/EVSForm";
import "./styles/CreacionEVS.css";

class CreacionEVS extends Component {
    state = {
        idEVS: null,
    };

    componentDidMount() {
        const { match } = this.props;
        const idEVS = match.params.id;
        this.setState({ idEVS });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        let titulo = "Crear EVS";
        if (this.state.idEVS) {
            titulo = "Editar EVS";
        }

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="configuraciones_activo"
                    titulo={titulo}
                    subtitulo=""
                    col="12"
                >
                    <EVSForm
                        idEVS={this.state.idEVS}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(CreacionEVS);
